module.exports = __webpack_public_path__ + "img/105.3.9d79920c.png";